import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import useLenis from "@/hooks/useLenis";

function App() {
  useLenis();
  return (
    <div className="grain min-h-screen bg-[#0a0705] text-[#f9f6f0]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#140e0a",
            border: "1px solid #2a1f17",
            color: "#f9f6f0",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
